module.exports = __webpack_public_path__ + "img/mcap.46e5f0a3.svg";